module.exports = __webpack_public_path__ + "static/img/zhengming.501e0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengming.jpg
// module id = JGih
// module chunks = 1